import * as React from "react";

function SvgLockOpenAlt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M16.5 12a1.46 1.46 0 011.07.43 1.47 1.47 0 01.42 1.07v9a1.45 1.45 0 01-.43 1.06 1.46 1.46 0 01-1.07.44h-15a1.46 1.46 0 01-1.06-.44 1.46 1.46 0 01-.44-1.06v-9a1.48 1.48 0 01.45-1.07A1.45 1.45 0 011.5 12h.49V7a6.75 6.75 0 012.07-4.95A6.74 6.74 0 018.99 0a6.74 6.74 0 015 2.05 6.74 6.74 0 012.05 5 .94.94 0 01-.29.7 1 1 0 01-.71.3h-1.05a1 1 0 01-1-1 3.85 3.85 0 00-1.17-2.83A3.85 3.85 0 008.99 3a3.84 3.84 0 00-2.81 1.17A3.86 3.86 0 004.99 7v5z" />
    </svg>
  );
}

const MemoSvgLockOpenAlt = React.memo(SvgLockOpenAlt);
export default MemoSvgLockOpenAlt;
